import request from '../utils/request';
// import qs from 'qs';
var baseUrl = "/faq";
import { $http } from './faq';

export function getMenu(){
    return $http({
        url: baseUrl + '/vuepressApp/v1/getMenu',
        method: 'post'
    })
}
export function getUuidByToken(data){
  return request({
      url: baseUrl + '/login/getUuidByToken',
      method: 'post',
      data: data
  })
}

export function getTokenByUuid(data){
  return request({
      url: baseUrl + '/login/getTokenByUuid',
      method: 'post',
      data: data
  })
}

export function logoutOpenSeeyon(data){
  return request({
      url: baseUrl + '/login/logout',
      method: 'post',
      data
  });
}